import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.85 15.44L20.85 19.44C20.936 19.5355 20.9819 19.6605 20.9782 19.789C20.9745 19.9175 20.9214 20.0396 20.83 20.13L20.13 20.83C20.0835 20.8768 20.0282 20.914 19.9673 20.9394C19.9064 20.9648 19.841 20.9779 19.775 20.9779C19.709 20.9779 19.6437 20.9648 19.5827 20.9394C19.5218 20.914 19.4665 20.8768 19.42 20.83L15.42 16.83C15.3094 16.7192 15.209 16.5987 15.12 16.47L14.37 15.47C13.1291 16.4609 11.5881 17.0004 10 17C8.41123 17.0055 6.86783 16.4703 5.62347 15.4825C4.3791 14.4947 3.50779 13.1129 3.15274 11.5643C2.79769 10.0157 2.98002 8.39237 3.66976 6.96111C4.3595 5.52984 5.51561 4.37579 6.94811 3.68862C8.38061 3.00144 10.0043 2.82202 11.5522 3.17985C13.1002 3.53767 14.4804 4.41145 15.466 5.65758C16.4516 6.90371 16.984 8.44807 16.9756 10.0368C16.9673 11.6256 16.4187 13.1643 15.42 14.4L16.42 15.09C16.5762 15.1899 16.7204 15.3073 16.85 15.44ZM7.22216 14.1573C8.04441 14.7067 9.01111 15 10 15C11.3261 15 12.5979 14.4732 13.5355 13.5355C14.4732 12.5978 15 11.326 15 9.99996C15 9.01106 14.7068 8.04436 14.1574 7.22211C13.608 6.39987 12.8271 5.75901 11.9134 5.38057C10.9998 5.00213 9.99447 4.90311 9.02456 5.09604C8.05466 5.28896 7.16374 5.76517 6.46448 6.46443C5.76522 7.16369 5.28901 8.05461 5.09609 9.02451C4.90316 9.99442 5.00218 10.9998 5.38061 11.9134C5.75905 12.827 6.39991 13.6079 7.22216 14.1573Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgSearchOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgSearchOutline;
